const TITLE_FORM = 'Ипотечный калькулятор';

export { TITLE_FORM };
